import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "col-6" }
const _hoisted_2 = { class: "col-8" }
const _hoisted_3 = { class: "fs-5 mb-0" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-6" }
const _hoisted_6 = { class: "col-3" }
const _hoisted_7 = { class: "col-3" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-3" }
const _hoisted_10 = { class: "col-9" }
const _hoisted_11 = { class: "col-6" }
const _hoisted_12 = { class: "row mt-4" }
const _hoisted_13 = { class: "col-auto" }
const _hoisted_14 = { class: "row bottom" }
const _hoisted_15 = { class: "col-12" }
const _hoisted_16 = { class: "d-inline-block pt-4 border-top border-2 border-light" }
const _hoisted_17 = {
  type: "submit",
  class: "btn btn-primary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!
  const _component_input_text = _resolveComponent("input-text")!
  const _component_BaseCardHeader = _resolveComponent("BaseCardHeader")!
  const _component_input_select = _resolveComponent("input-select")!
  const _component_BaseCardBody = _resolveComponent("BaseCardBody")!
  const _component_BaseCard = _resolveComponent("BaseCard")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_dp_form = _resolveComponent("dp-form")!
  const _component_base_container = _resolveComponent("base-container")!

  return (_openBlock(), _createBlock(_component_base_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_BaseTitle, {
        title: _ctx.$t('deliveryPickupLocation'),
        mb: 5,
        "show-refresh-button": "",
        onRefresh: _ctx.reloadContent,
        "back-route": {name: 'delivery-pickup-locations'}
      }, null, 8, ["title", "onRefresh"]),
      _createVNode(_component_AlertError2, {
        error: _ctx.pageUI.getError()
      }, null, 8, ["error"]),
      _createVNode(_component_BaseSpinner, {
        spin: !_ctx.pageUI.getIsReady()
      }, null, 8, ["spin"]),
      _createElementVNode("div", null, [
        (_ctx.pageUI.getIsReady())
          ? (_openBlock(), _createBlock(_component_dp_form, {
              key: 0,
              as: "form",
              onSubmit: _ctx.submitData,
              novalidate: ""
            }, {
              default: _withCtx(({ errors }) => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_input_text, {
                    modelValue: _ctx.detailModel.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.detailModel.name) = $event)),
                    label: _ctx.$t('name'),
                    name: "name",
                    rules: "required|min:3",
                    errors: errors
                  }, null, 8, ["modelValue", "label", "errors"])
                ]),
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_BaseCard, { class: "fallback border-light mb-3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_BaseCardHeader, { class: "p-2" }, {
                        default: _withCtx(() => [
                          _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t('address')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_BaseCardBody, { class: "p-2" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                              _createVNode(_component_input_text, {
                                class: "mt-2",
                                modelValue: _ctx.detailModel.address!.street,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.detailModel.address!.street) = $event)),
                                label: _ctx.$t('street'),
                                name: "street",
                                errors: errors
                              }, null, 8, ["modelValue", "label", "errors"])
                            ]),
                            _createElementVNode("div", _hoisted_6, [
                              _createVNode(_component_input_text, {
                                class: "mt-2",
                                modelValue: _ctx.detailModel.address!.house_number,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.detailModel.address!.house_number) = $event)),
                                label: _ctx.$t('houseNr'),
                                name: "houseNr",
                                errors: errors
                              }, null, 8, ["modelValue", "label", "errors"])
                            ]),
                            _createElementVNode("div", _hoisted_7, [
                              _createVNode(_component_input_text, {
                                class: "mt-2",
                                modelValue: _ctx.detailModel.address!.box,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.detailModel.address!.box) = $event)),
                                label: _ctx.$t('box'),
                                name: "box",
                                errors: errors
                              }, null, 8, ["modelValue", "label", "errors"])
                            ])
                          ]),
                          _createVNode(_component_input_text, {
                            class: "mt-2",
                            modelValue: _ctx.detailModel.address!.extra_address_line,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.detailModel.address!.extra_address_line) = $event)),
                            label: _ctx.$t('extraAddress'),
                            name: "extraAddress",
                            errors: errors
                          }, null, 8, ["modelValue", "label", "errors"]),
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                              _createVNode(_component_input_text, {
                                class: "mt-2",
                                modelValue: _ctx.detailModel.address!.postal_code,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.detailModel.address!.postal_code) = $event)),
                                label: _ctx.$t('postalCode'),
                                name: "postalCode",
                                errors: errors
                              }, null, 8, ["modelValue", "label", "errors"])
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                              _createVNode(_component_input_text, {
                                class: "mt-2",
                                modelValue: _ctx.detailModel.address!.city_name,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.detailModel.address!.city_name) = $event)),
                                label: _ctx.$t('city'),
                                name: "city",
                                errors: errors
                              }, null, 8, ["modelValue", "label", "errors"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_11, [
                            _createVNode(_component_input_select, {
                              modelValue: _ctx.detailModel.address!.country_name,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.detailModel.address!.country_name) = $event)),
                              label: _ctx.$t('country'),
                              name: "country",
                              options: _ctx.countriesForDropdown,
                              errors: errors
                            }, null, 8, ["modelValue", "label", "options", "errors"])
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_input_select, {
                        modelValue: _ctx.detailModel.status_code,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.detailModel.status_code) = $event)),
                        name: "status",
                        selectText: _ctx.$t('selectText'),
                        options: _ctx.statusOptions,
                        rules: "required",
                        errors: errors
                      }, null, 8, ["modelValue", "selectText", "options", "errors"])
                    ])
                  ])
                ]),
                _createElementVNode("section", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("button", _hoisted_17, _toDisplayString(_ctx.$t('save')), 1),
                      _createVNode(_component_router_link, {
                        class: "ms-3 btn btn-outline-primary",
                        to: {name: 'delivery-pickup-locations',}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('cancel')), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["onSubmit"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}